import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import {serviceMotionList} from '../../utils/serviceMotionList';

import FeatureCardBox from '../common/FeatureCardBox';

import {ReactComponent as ChartImg} from '../../assets/chat02/chart.svg';
import {ReactComponent as ChartSmallImg} from '../../assets/chat02/chart-sm.svg';
import {ReactComponent as ChartMediumImg} from '../../assets/chat02/chart-md.svg';
import {ReactComponent as ChartLargeImg} from '../../assets/chat02/chart-lg.svg';
import {ReactComponent as SearchImg} from '../../assets/chat02/search.svg';
import {ReactComponent as TableImg} from '../../assets/chat02/table.svg';

export default function Chat02() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');
    const mobileLarge = useMediaQuery('(min-width: 769px) and (max-width: 1024px)');

    const getChartImg = () => {
        if (mobileSmall) return ChartSmallImg;
        if (mobileMedium) return ChartMediumImg;
        if (mobileLarge) return ChartLargeImg;
        
        return ChartImg;
    };

    const dataMap = [
        { 
            type: 'table',
            title: '표 형식의 답변',
            subTitle: '복잡한 DB 정보는 표 형식으로 답변해 드려요',
            Image: TableImg
        },
        { 
            type: 'chart',
            title: '그래프 형식의 답변',
            subTitle: mobileMedium ? <>표, 그래프 등 원하는 방식으로 데이터를 볼 수<br />있어요</> : '표, 그래프 등 원하는 방식으로 데이터를 볼 수 있어요',
            Image: getChartImg()
        }
    ];

    return (
        <FeatureCardBox
            type='data'
            IconImage={SearchImg}
            keyword='정보 검색'
            title={(mobileSmall || mobileMedium) ? <>DB를 기반으로<br /> 실시간 데이터를 찾아드려요!</> : 'DB를 기반으로 실시간 데이터를 찾아드려요!'}
            featureCardList={dataMap}
            titleMotion={serviceMotionList.titleMotion}
            cardMotion={serviceMotionList.cardMotion}
            motionVariant={serviceMotionList.chat02}
        />
    );
}
